import React from "react";
import { AlertTriangle } from "lucide-react";

export default function Warning() {
  const warnings = [
    "Specified store URL matches this store URL",
    "Primary exchange rate currency is set",
    "Primary store currency is set",
    "Default weight is set",
    "Default dimension is set",
    "Payment methods are OK",
    "Uninstall and delete the plugin(s) that you don't use: Facebook authentication, Google Authenticator, UPS (United Parcel Service), Avalara tax provider, accessiBe, Facebook Pixel (Uninstall and delete all not used plugins automatically (site will be restarted))",
    "You haven't installed the following plugin(s): Azure Blob Storage, Cloudflare Images. You may delete the plugins you don't use in order to decrease startup time",
  ];

  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <h1 className="text-2xl font-semibold text-gray-800 flex items-center gap-2">
          <AlertTriangle className="text-yellow-600" /> Warnings
        </h1>
        <button className="mt-3 sm:mt-0 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium">
          Refresh
        </button>
      </div>

      {/* Description */}
      <div className="bg-blue-50 border border-blue-200 text-blue-800 p-4 rounded-lg text-sm mb-5">
        This page lists important configuration warnings and plugin issues
        detected in your system.
      </div>

      {/* Warning List */}
      <div className="bg-white shadow-sm rounded-xl p-4 sm:p-6">
        <ul className="space-y-3">
          {warnings.map((item, index) => (
            <li
              key={index}
              className="flex items-start gap-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-gray-800 hover:bg-yellow-100 transition-colors"
            >
              <AlertTriangle className="text-yellow-600 flex-shrink-0 mt-1" />
              <span className="text-sm sm:text-base leading-relaxed">
                {item}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Footer */}
      <div className="text-sm text-gray-500 mt-6 text-center">
        <p>1–{warnings.length} of {warnings.length} warnings</p>
      </div>
    </div>
  );
}
